import script from "./MessageImage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MessageImage.vue?vue&type=script&setup=true&lang=ts"

import "./MessageImage.vue?vue&type=style&index=0&id=adeabf60&lang=scss"

const __exports__ = script;

export default __exports__